import { useEffect, useRef, useState } from "react";

const ReadMoreText = ({ text }) => {
    const [showButton, setShowButton] = useState(false);
    const textRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight) || 20;
                const maxHeight = lineHeight * 2; // Max height for 2 lines
                const isOverflowing = textRef.current.scrollHeight > maxHeight;
                // Check if content is overflowing
                if (isOverflowing) {
                    setShowButton(true);
                } else {
                    setShowButton(false);
                };
            }
        };

        // Wait for component to mount
        setTimeout(checkOverflow, 100);

        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [text]); // Runs when text changes
    return (

        <div>
            <small ref={textRef} style={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: isExpanded ? "unset" : 2, 
                transition: "all 0.3s ease-in-out",
                wordBreak: "break-word"
            }}>
                {text}
            </small>
            {showButton && (
                <span className="read_more pointer" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? "Read Less" : "Read More"}
                </span>
            )}
        </div>
    );
}
export default ReadMoreText